import React, { useState, useEffect, useLayoutEffect, useRef } from "react";
import { useInView } from 'react-intersection-observer';
import HotspotController from "./HotspotController";
import IeHotspotController from "./IeHotspotController";

// import jsonData from "../../assets/data.json";

import { DataInterface } from "../types/DataInterface";

import "../../styles/main.sass";

// const data: DataInterface[] = jsonData;

let frameHeight: number | undefined = 0;

// https://stackoverflow.com/questions/49328382/browser-detection-in-reactjs
// @ts-ignore
const isFirefox: boolean = typeof InstallTrigger !== "undefined";
// @ts-ignore
const isIE = /*@cc_on!@*/ false || !!document.documentMode;

const Main = () => {
  const containerRef = useRef<HTMLDivElement>(null);
  const [hotspots, setHotspots] = useState<DataInterface[] | null>(null);
  // const [inView, setInView] = useState<boolean>(!isFirefox);
  // const [intersecting, setIntersecting] = useState<boolean>(false);

  const [ref, inView] = useInView({
    threshold: 0.1,
  });
  
  async function loadPolyfills() {
    if (typeof window.IntersectionObserver === 'undefined') {
      await import('intersection-observer');
    }
  }

  // only on initializations
  useEffect(() => {
    loadPolyfills();
    loadJson();
    updateSize();
    // setTimeout(() => {
    //   startObservation();
    // }, 250);
  }, []);

  // useEffect(() => {
  //   console.log("IS IN VIEW", inView);
  // }, [inView]);

  // const startObservation = () => {
  //   if (!containerRef || !containerRef.current) return;
  //   const observer = new IntersectionObserver(
  //     ([entry]) => {
  //       if (entry.isIntersecting) {
  //         setIntersecting(entry.isIntersecting);
  //         observer.disconnect();
  //       }
  //     },
  //     { threshold: 0.01 }
  //   );
  //   observer.observe(containerRef.current);
  // };

  const updateSize = () => {
    const innerHeight: number | undefined = containerRef?.current?.offsetHeight;
    if (innerHeight === frameHeight) return;
    frameHeight = innerHeight;

    const payload = {
      msgType: "childHeightChanged",
      height: frameHeight,
    };

    window.parent.postMessage(payload, "*");
  };

  useLayoutEffect(() => {
    window.addEventListener("resize", updateSize);

    return () => window.removeEventListener("resize", updateSize);
  }, []);

  const handleJSONLoaded = (e: any) => {
    const data = JSON.parse(e.currentTarget.responseText);
    setHotspots(data);
  };

  const loadJson = () => {
    const pathPrefix = process.env.NODE_ENV === 'production' ? './assets' : '../assets';
    const filename =  `${pathPrefix}/data-${process.env.REACT_APP_LOCALE}.json`;
    const xhr = new XMLHttpRequest();
    xhr.addEventListener("load", handleJSONLoaded);
    xhr.open("GET", filename);
    xhr.send();
  };

  return (
    <div ref={containerRef} className="container-wrapper">
      <div ref={ref} className={`container locale-${process.env.REACT_APP_LOCALE} ${!hotspots ? 'loading' : ''}`}>
        {hotspots ? (
          isIE ? (
            <IeHotspotController hotspotData={hotspots} />
          ) : (
            <HotspotController
              hotspotData={hotspots}
              inView={inView}
              isFF={isFirefox}
              // onStartClick={() => setIntersecting(true)}
            />
          )
        ) : (
          <div className="loader"></div>
        )}
      </div>
    </div>
  );
};

export default Main;
